import App from 'app/app.js';
import LtSelectionDrawerCtrl from 'app/directive/LtSelectionDrawerCtrl.js';

function LtInstantPromoPopupCtrl($scope, $timeout) {
  LtSelectionDrawerCtrl.call(this, $scope, $timeout);

  this.selected = $scope.selected;
  this.next = $scope.next;
  this.prev = $scope.prev;
  this.showDisoucntHeader = $scope.discount;

  this.addClick = function (s) {
    $scope.addClick({ skuCode: s.skuCode });
  };

  this.personalizeClick = function (s) {
    $scope.personalizeClick({ skuCode: s.skuCode });
  };

  this.goCart = function (i) {
    $scope.goCart({ item: i.item });
  };

  this.navPrev = function () {
    $scope.navPrev();
  };

  this.navNext = function () {
    $scope.navNext();
  };

  this.popAction = function () {
    $scope.popAction();
  };
}

App.controller('LtInstantPromoPopupCtrl', ['$scope', '$timeout', LtInstantPromoPopupCtrl]);
